import {JwtHelper, AuthHttp, AuthConfig} from 'angular2-jwt';
import {Injectable, OnInit} from '@angular/core';
import {Http, Response, Headers, RequestOptions} from '@angular/http';
import {environment} from '../../../environments/environment';
import {User} from '../../models/user';
import {Token} from '../../models/token';
import * as _ from 'lodash';
import {LoggedUserData} from "../../models/loggedUserData";
import {Router} from "@angular/router";
import {AuthRESTService} from '../../components/services/rest/auth-rest.service';
import {Observable} from "rxjs/Observable";
import 'rxjs/add/observable/forkJoin';

@Injectable()
export class AuthControllerService{

    static showRegisteredMessage = false;
    baseUrl: string = environment.authUrl;
    OAuthRedirectUrl: string = environment.OAuthRedirectUrl;
    OAuthClientId: string = environment.OAuthClientId;
    OAuthSecret: string = environment.OAuthSecret;
	jwtHelper: JwtHelper = new JwtHelper();
	userRoles: string[] = []; 
    private subscribers: (() => void)[] = [];

    savedToken() {
        const token = localStorage.getItem(Token.tokeNameInSotage);
        //I have no idea how that is possible
        if (token === 'null') {
            this.router.navigate(['/login']);
        }
        return token;
    }

    savedRefreshToken() {
        return localStorage.getItem(Token.refreshTokenNameInStorage);
    }

    constructor(private http: Http, private router: Router, private rest: AuthRESTService) {
        this.askRoles()
    }

    register(user: User) {
        return this.http.put(this.baseUrl + 'new_user', user, new RequestOptions({
                headers: new Headers({
                    'Authorization': 'Basic ' + btoa(this.OAuthClientId + ':' + this.OAuthSecret)
                })
            })
        ).map(res => res.json())
    }

    login(authenticationCode: string) {
        return this.http.post(this.baseUrl + 'access_token',
            this.jsonToQueryString({
                grant_type: 'authorization_code',
                code: authenticationCode,
                redirect_uri: this.OAuthRedirectUrl
            }),
            new RequestOptions({
                headers: new Headers({
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': 'Basic ' + btoa(this.OAuthClientId + ':' + this.OAuthSecret)
                })
            })
        ).map(res => res.json()).map((res) => this.saveAccessAndRefreshToken(res))
    }

    refreshToken() {
        return this.http.post(this.baseUrl + 'access_token',
            this.jsonToQueryString({
                grant_type: 'refresh_token',
                refresh_token: this.savedRefreshToken(),
                redirect_uri: this.OAuthRedirectUrl
            }),
            new RequestOptions({
                headers: new Headers({
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': 'Basic ' + btoa(this.OAuthClientId + ':' + this.OAuthSecret)
                })
            })
        ).map(res => res.json()).map((res) => this.saveAccessAndRefreshToken(res));
    }

    private saveAccessAndRefreshToken(response: any) {
        const token = response.access_token;
        if (this.isValid(token)) {
			this.saveAuthToken(token);
			this.saveRefreshToken(response.refresh_token);
			this.askRoles();
			return response;
        }
        return false;
	};

    private askRoles() {
        this.rest.get('user/attributes').subscribe((roles) => {
            if (roles && roles.length) {
                this.userRoles = roles;
            }
            else {
                this.userRoles = [];
            }
            this.notifySubscribers();
        });
	}

	// this is to support guard API which expects observable returned
	askRolesObservable() {
		return this.rest.get('user/attributes').map((roles) => {
            if (roles && roles.length) {
                this.userRoles = roles;
            }
            else {
                this.userRoles = [];
			}
        });
	}

    subscribeForTokenChange(subscriber: () => void) {
		this.subscribers.push(subscriber);
	}

	unsubscribe(subscriber: () => void) {
		this.subscribers = this.subscribers.filter((sub) => {
			return sub !== subscriber; 
		});
	}
	
    notifySubscribers() {
        this.subscribers.forEach(it => it());
    }

    isLogged() {
        return this.isSavedTokenValid();
    }

    loggedUser() {
		if (!this.isLogged()) return;
        return this.savedUser();
	}
	
	resolveRole(role: string) {
		if (!this.loggedUser() || !this.userRoles.length) {
			return false;
		};
		if (this.userRoles.indexOf('sysadmin') !== -1) return true; //has every role
		return this.userRoles.indexOf(role) !== -1;
	}


    isUserEmailVerified() {
        return this.loggedUser().email_verified;
    }

    isUserVerified() {
        return this.loggedUser().user_verified;
    }

    requestNewPassword(username: string) {
        if (!username) {
            throw new Error('Please fill login name !');
        }
        return this.http.post(this.baseUrl + '/user/password/new', {'username': username})
    }

    logout() {
        const authHeader = this.getAuthHeader();
        this.http.get(this.baseUrl + 'userdata/invalidateToken', authHeader).subscribe(
            () => {
                this.removeTokens();
            },
            () => {
                this.removeTokens();
            }
        );
        this.removeTokens();
        this.router.navigate(['/login']);
    }

    private getAuthHeader() {
        return {headers: new Headers({'Authorization': 'Bearer ' + this.savedToken()})};
    }

    randomId() {
        let text = '';
        let possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        for (let i = 0; i < 15; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        return text;
    }

    isSavedTokenValid() {
        const token = this.savedToken();
        return token && this.isValid(token);
    }

    isAnyTokenPresent() {
        return !!this.savedToken()
    }

    getSearchParameters(): any {
        const prmstr = window.location.search.substr(1);
        return prmstr != null && prmstr != '' ? this.transformToAssocArray(prmstr) : {};
    }

    savedTokenHasExpired() {
        return this.jwtHelper.isTokenExpired(this.savedToken())
    }

    savedTokenIsAboutToExpireIn5Minutes() {
        return this.jwtHelper.isTokenExpired(this.savedToken(), 60 * 5)
    }

    savedTokenIsExpiredFor20Hours() {
        return this.jwtHelper.isTokenExpired(this.savedToken(), -(60 * 60 * 20))
    }

    confirmMail(): Observable<any> {
        return this.http.post(this.baseUrl + 'email/verify?client_id=' + this.OAuthClientId,
            {},
            this.getAuthHeader()
        )
    }

    saveAuthToken(token) {
        localStorage.setItem(Token.tokeNameInSotage, token);
        this.notifySubscribers()
    }

    private transformToAssocArray(prmstr): object {
        let params = {};
        let prmarr = prmstr.split('&');
        for (let i = 0; i < prmarr.length; i++) {
            let tmparr = prmarr[i].split('=');
            params[tmparr[0]] = tmparr[1];
        }
        return params;
    }

    private requestAuthToken(authCode: string): Observable<any> {
        return this.http.post(this.baseUrl + 'access_token',
            this.jsonToQueryString({
                grant_type: 'authorization_code',
                code: authCode,
                redirect_uri: this.OAuthRedirectUrl
            }),
            new RequestOptions({
                headers: new Headers({
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': 'Basic ' + btoa(this.OAuthClientId + ':' + this.OAuthSecret)
                })
            })
        ).map(res => res.json())
    }


    private jsonToQueryString(json: any) {
        return Object.keys(json).map(function (key) {
            return encodeURIComponent(key) + '=' +
                encodeURIComponent(json[key]);
        }).join('&');
    }

    private removeTokens() {
        localStorage.removeItem(Token.tokeNameInSotage);
        localStorage.removeItem(Token.refreshTokenNameInStorage);
    }


    private saveRefreshToken(token) {
        localStorage.setItem(Token.refreshTokenNameInStorage, token);
    }

    isValid(token) {
        try {
            const user = this.parseToken(token);
            return token !== undefined &&
                user !== undefined;
        } catch (e) {
            return false
        }
    }

    private parseToken(token) {
        return this.jwtHelper.decodeToken(token);
    }

    private savedUser() {
        return { ...this.parseToken(this.savedToken()), ...{ roles: this.userRoles } };
    }

}



// WEBPACK FOOTER //
// ./src/app/services/auth-controller/auth-controller.service.ts